import { Card, Metadata } from "@dropbox/dash-component-library";
import { Text } from "@dropbox/dig-components/typography";

import { Truncate } from "@dropbox/dig-components/truncate";
import styles from "./StackSourceCard.module.css";

import { UrlSrcIcon } from "@mirage/shared/icons";
import { FileContentIcon } from "@mirage/shared/icons/FileContentIcon";
import i18n from "@mirage/translations";
import { useMemo } from "react";
import { StackConversationSource } from "./types";

type StackMoreSourcesCardProps = {
  onClick: () => void;
  sources: StackConversationSource[];
};

export function StackMoreSourcesCard({
  onClick,
  sources,
}: StackMoreSourcesCardProps) {
  const sourceIcons = useMemo(() => {
    return sources.slice(0, 5).map((source) => {
      return typeof source.icon === "string" ? (
        <UrlSrcIcon
          iconUrl={source.icon}
          name={typeof source.title === "string" ? source.title : ""}
          size={16}
        />
      ) : null;
    });
  }, [sources.length]);

  return (
    <Card className={styles.stackSourceCard} isLink variant="outline">
      <Card.Contents breakout="large">
        <Card.OverlayLink onClick={onClick} href={"#"}>
          <Text size="medium" className={styles.stackSourceCardTitle}>
            <Truncate lines={2}>
              {i18n.t("stack_more_sources", { count: sources.length })}
            </Truncate>
          </Text>
        </Card.OverlayLink>
      </Card.Contents>
      <Card.Contents breakout="large">
        <Metadata
          className={styles.stackSourceCardMetadata}
          size="small"
          withDividers="blank"
        >
          {sources.slice(0, 5).map((source, i) => {
            return (
              <Metadata.Item key={source.uuid}>
                <FileContentIcon
                  content={source}
                  hasBackground={false}
                  icon={sourceIcons[i]}
                  size="small"
                />
              </Metadata.Item>
            );
          })}
        </Metadata>
      </Card.Contents>
    </Card>
  );
}
